import { createApiClient } from '@room/frontend-sdk';

const apiClient = createApiClient({
  baseURL: '/api',
});

const logApiError = (method: string, url: string, error: unknown) => {
  const errorInfo = {
    timestamp: new Date().toISOString(),
    method,
    url,
    error: (error as Error)?.message || String(error),
  };
  console.error('[API Error]', errorInfo);
};

export const api = {
  async get<T = unknown>(url: string): Promise<T> {
    try {
      return await apiClient.get<T>(url);
    } catch (error) {
      logApiError('GET', url, error);
      throw error;
    }
  },
  async post<T = unknown>(url: string, data?: unknown): Promise<T> {
    try {
      return await apiClient.post<T>(url, data);
    } catch (error) {
      logApiError('POST', url, error);
      throw error;
    }
  },
};
